import { useQuery } from '@tanstack/react-query';
import { HttpError, notUndefined } from 'common-utils';
import { useVoucherCode } from 'preflight-core';

import { getVoucher, Voucher } from './get-voucher';

export function useVoucher({
  publisherId,
  journalId,
}: {
  publisherId: string;
  journalId: string;
}) {
  const voucherCode = useVoucherCode();

  const voucherQuery = useQuery<Voucher, HttpError>({
    queryKey: ['voucher', voucherCode, publisherId, journalId],
    queryFn: () =>
      getVoucher({
        publisherId,
        journalId,
        voucherCode: voucherCode!,
      }),
    enabled: notUndefined(voucherCode),
  });

  return voucherQuery;
}
